import React from "react"
import { SvgIcon, SvgIconProps } from "@material-ui/core"

export default function Absence(props: SvgIconProps) {
  return (
    <SvgIcon {...props}>
      <path
        xmlns="http://www.w3.org/2000/svg"
        d="M9.33337 4C7.12004 4 5.33337 5.78667 5.33337 8C5.33337 10.2133 7.12004 12 9.33337 12C11.5467 12 13.3334 10.2133 13.3334 8C13.3334 5.78667 11.5467 4 9.33337 4ZM9.33337 10C8.17337 10 7.33337 9.16 7.33337 8C7.33337 6.84 8.17337 6 9.33337 6C10.4934 6 11.3334 6.84 11.3334 8C11.3334 9.16 10.4934 10 9.33337 10Z"
      />
      <path
        xmlns="http://www.w3.org/2000/svg"
        d="M1.33337 16.6667C1.33337 14.0067 6.66004 12.6667 9.33337 12.6667C12.0067 12.6667 17.3334 14.0067 17.3334 16.6667V20H15.3334V16.6667C15.3334 16.0267 12.3067 14.6667 9.33337 14.6667C6.36004 14.6667 3.33337 16.0267 3.33337 16.6667V20H1.33337V16.6667Z"
      />
      <path
        xmlns="http://www.w3.org/2000/svg"
        d="M21.08 8.17333L19.6667 9.58667L18.2534 8.17333L16.84 9.58667L18.2534 11L16.84 12.4133L18.2534 13.8267L19.6667 12.4133L21.08 13.8267L22.4934 12.4133L21.08 11L22.4934 9.58667L21.08 8.17333Z"
      />
    </SvgIcon>
  )
}
